'use client';

import React from 'react';
import classNames from 'classnames';
import { IndustryTilesComponent } from '@sapientpro/sapientpro-data-models';
import styles from './IndustrySection.module.scss';
import IndustryCard from './IndustryCard';
import AnimatedTitle from '../AnimatedTitle';

type IndustrySectionProps = {
  data: IndustryTilesComponent & { title: string };
  threeColumns?: boolean;
  wrap?: boolean;
};

export default function IndustrySection({ data, threeColumns = false, wrap = false }: IndustrySectionProps) {
  return (
    <section className={classNames(styles.industriesSection, 'container')}>
      <div className={styles.industriesSectionHead}>
        <h2 className={classNames(styles.industriesSection__title, 'header2')}>
          <AnimatedTitle title={data.title} />
        </h2>
        {data.description && <p className={classNames(styles.description, 'bodyLarge')}>{data.description}</p>}
      </div>
      <div className={classNames(styles.industriesSection__list, {
        [styles.industriesSection__list_threeColumns]: threeColumns,
        [styles.industriesSection__list_wrap]: wrap,
      })}
      >
        {data.list.map(industry => (
          <IndustryCard
            industry={industry}
            key={industry.id}
          />
        ))}
      </div>
    </section>
  );
}
